export const CREATE_TASK_REQUEST = "CREATE_TASK_REQUEST";
export const CREATE_TASK_REQUEST_SUCCESS = "CREATE_TASK_REQUEST_SUCCESS";
export const CREATE_TASK_REQUEST_FAILED = "CREATE_TASK_REQUEST_FAILED";

export const FETCH_TASKS_REQUEST = "FETCH_TASKS_REQUEST";
export const FETCH_TASKS_REQUEST_SUCCESS = "FETCH_TASKS_REQUEST_SUCCESS";
export const FETCH_TASKS_REQUEST_FAILED = "FETCH_TASKS_REQUEST_FAILED";

export const DELETE_TASK_REQUEST = "DELETE_TASK_REQUEST";
export const DELETE_TASK_REQUEST_SUCCESS = "DELETE_TASK_REQUEST_SUCCESS";
export const DELETE_TASK_REQUEST_FAILED = "DELETE_TASK_REQUEST_FAILED";

export const FETCH_TASK_REQUEST = "FETCH_TASK_REQUEST";
export const FETCH_TASK_REQUEST_SUCCESS = "FETCH_TASK_REQUEST_SUCCESS";
export const FETCH_TASK_REQUEST_FAILED = "FETCH_TASK_REQUEST_FAILED";

export const UPDATE_TASK_REQUEST = "UPDATE_TASK_REQUEST";
export const UPDATE_TASK_REQUEST_SUCCESS = "UPDATE_TASK_REQUEST_SUCCESS";
export const UPDATE_TASK_REQUEST_FAILED = "UPDATE_TASK_REQUEST_FAILED";